import regeneratorRuntime from "/app/node_modules/.pnpm/next@12.1.0_7f5822f691c4f776e4f56a7840bed181/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
/* eslint-disable max-len */ import { Modal } from '@tencent/intl-design-ui';
import { STATUS_NUM } from 'common/constants';
import logger from 'common/utils/udp-logger';
import { t } from 'common-translation/tools';
import cookie from 'js-cookie';
import { KEY_INTL_PREVIEW, KEY_LONG_PREVIEW, KEY_PREVIEW } from 'portal-common/constants';
import request from 'portal-common/service/fetch';
import store from 'portal-common/store';
import { T_CAPTCHA_ID } from '../../common/constants';
import { getOpmList } from '../../service/fetchService';
import { ACTIVITY_TYPE, VERIFY_SUCCESS_CODE } from './constants';
import dataFormat from './utils/data-format';
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
// 判断是否为预览模式
var isPreview = function() {
    return ~~(location.href.includes(KEY_PREVIEW) || location.href.includes(KEY_LONG_PREVIEW) || Number(cookie.get(KEY_INTL_PREVIEW)) === STATUS_NUM.TRUE_NUM);
};
export var asyncSubmitFormTable = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(item) {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    request.post('/render/api/configsolution/registerStep', {}, {
                        timeout: 6 * 1000
                    }).then(function(result) {
                        var code = result.code, _data = result.data, resCode = _data.code, step = _data.step, msg = _data.msg;
                        if (code === 200 && resCode === -1000) {
                            window.location.href = "".concat(location.origin, "/login?s_url=").concat(encodeURIComponent(location.href));
                        } else if (code === 0) {
                            if (999 !== parseInt(step, 10)) {
                                asyncRegisterStepDialog();
                            } else {
                                submitForm(item, true);
                            }
                        } else {
                            Modal.alert({
                                size: 'small',
                                icon: 'info-circle',
                                title: t('Tips'),
                                content: msg,
                                btnOkMsg: t('I got it')
                            });
                        }
                    }).catch(function(err) {
                        logger.error('registerStep', {
                            err: err
                        });
                    });
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function asyncSubmitFormTable(item) {
        return _ref.apply(this, arguments);
    };
}();
export var submitForm = function() {
    var _ref1 = _asyncToGenerator(regeneratorRuntime.mark(function _callee1(item, isValidate) {
        var captcha1;
        return regeneratorRuntime.wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    captcha1 = new window.Captcha(T_CAPTCHA_ID, function() {
                        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(res) {
                            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        try {
                                            if (res.ret === 0) {
                                                // 天域获取设备指纹信息, 返回加密信息
                                                request.post('/render/api/configsolution/verifyCoupon', {
                                                    eventId: item.event,
                                                    ecId: item.commodity,
                                                    captcha: res,
                                                    isValidate: isValidate,
                                                    ciphertext: '',
                                                    formInfo: JSON.stringify(item.formData)
                                                }, {
                                                    timeout: 12 * 1000
                                                }).then(function(data) {
                                                    var ref = data || {}, _code = ref.code, code = _code === void 0 ? -1 : _code;
                                                    // 统一处理表单提交结果反馈，用自定义领取的那套文案
                                                    doVerifyCouponResult(item, code);
                                                }).catch(function(err) {
                                                    console.error(err);
                                                });
                                            }
                                        } catch (err) {
                                            console.error(err);
                                        }
                                    case 1:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(res) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    captcha1.show(); // 显示验证码
                case 2:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1);
    }));
    return function submitForm(item, isValidate) {
        return _ref1.apply(this, arguments);
    };
}();
export var asyncReceiveCommodity = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(item) {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (item.isConnect) {
                        _ctx.next = 3;
                        break;
                    }
                    if (item.but_href) {
                        window.location.href = item.but_href;
                    } else if (item.href) {
                        window.location.href = item.href;
                    }
                    return _ctx.abrupt("return");
                case 3:
                    request.post('/render/api/configsolution/getBillAccountInfo', {}, {
                        timeout: 12 * 1000
                    }).then(function(result) {
                        var tmp = result.code, resCode = tmp === void 0 ? '' : tmp, isOpen = result.isOpen, total = result.total;
                        if (resCode === -1000) {
                            window.location.href = "".concat(location.origin, "/login?s_url=").concat(encodeURIComponent(location.href));
                        } else if (isOpen) {
                            // 账号已开户
                            receiveCommodity(item, true);
                        } else if (total) {
                            // 账号未开户，账号已绑卡
                            asyncAccountNoCardDialog();
                        } else {
                            // 账号未开户，账号未绑卡
                            asyncRegisterStepDialog();
                        }
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function asyncReceiveCommodity(item) {
        return _ref.apply(this, arguments);
    };
}();
var receiveCommodity = function() {
    var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(item, isValidate) {
        var captcha1;
        return regeneratorRuntime.wrap(function _callee$(_ctx2) {
            while(1)switch(_ctx2.prev = _ctx2.next){
                case 0:
                    captcha1 = new window.Captcha(T_CAPTCHA_ID, function() {
                        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(res) {
                            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        try {
                                            if (res.ret === 0) {
                                                // 天域获取设备指纹信息, 返回加密信息
                                                request.post('/render/api/configsolution/verifyCoupon', {
                                                    eventId: item.event,
                                                    ecId: item.commodity,
                                                    captcha: res,
                                                    isValidate: isValidate,
                                                    ciphertext: ''
                                                }, {
                                                    timeout: 12 * 1000
                                                }).then(function(data) {
                                                    var ref = data || {}, _code = ref.code, code = _code === void 0 ? -1 : _code;
                                                    // window.recordBehavior
                                                    //   && window.recordBehavior.reportEvent('click_free_credit_success', { ext1: item.eventType, ext2: code }); // 领取结果上报，新增类型和结果码
                                                    // 统一处理领劵结果反馈
                                                    doVerifyCouponResult(item, code);
                                                }).catch(function(err) {
                                                    console.error(err);
                                                });
                                            }
                                        } catch (err) {
                                            console.error(err);
                                        }
                                    case 1:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(res) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    captcha1.show(); // 显示验证码
                case 2:
                case "end":
                    return _ctx2.stop();
            }
        }, _callee2);
    }));
    return function receiveCommodity(item, isValidate) {
        return _ref2.apply(this, arguments);
    };
}();
/** *
 * 统一处理领劵结果
 *@param item 点击领取传入的一系列参数
 *@param code 错误码
 *  */ var doVerifyCouponResult = function(item1, code) {
    var isVerifySuccess = VERIFY_SUCCESS_CODE === code;
    var itemHref = item1.but_href || item1.href;
    var hasNoModel = item1.hasNoModel, _eventType = item1.eventType, eventType = _eventType === void 0 ? ACTIVITY_TYPE.OTHER : _eventType;
    // 领取成功状态&不需要弹窗&链接不为空，直接走跳转逻辑
    if (isVerifySuccess && hasNoModel && itemHref) {
        window.location.href = itemHref;
        return;
    }
    getOpmList({
        lang: store.getLang(),
        preview: isPreview(),
        eventType: eventType
    }).then(function(info) {
        var infoTipList = (info || []).filter(function(item) {
            return item.filedStatus === "".concat(code);
        });
        var infoTip = infoTipList[0] || {};
        var btnOkHref = infoTip.filedHref || ''; // 配置的错误码对应的弹框按钮链接
        var filedFiledTips = infoTip.filedFiledTips || t('Sorry, you have failed to participate this activity');
        if (isVerifySuccess) {
            // 成功情况下弹窗按钮跳转链接取按钮绑定的href
            if (itemHref) {
                btnOkHref = itemHref;
            }
            if (hasNoModel && btnOkHref) {
                window.location.href = btnOkHref;
                return;
            }
            filedFiledTips = infoTip.filedFiledTips || t('successful registration');
        }
        Modal.alert({
            size: 'large',
            showCloseIcon: true,
            type: isVerifySuccess ? 'p-fb' : 'n-fb',
            icon: isVerifySuccess ? 'check-circle' : 'info-circle',
            title: infoTip.filedTitle || t('Tips'),
            content: filedFiledTips,
            btnOkMsg: infoTip.filedBtnTxt || t('I got it'),
            onOk: btnOkHref ? _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            window.location.href = btnOkHref;
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            })) : null
        });
    });
};
export var doComponentsBgColorEvent = function(styleItem, bgColor) {
    if (!bgColor) {
        return styleItem;
    }
    if (bgColor.toLocaleUpperCase() === '#EEF5FF') {
        return {
            backgroundImage: 'linear-gradient(180deg, #DAE5F2 0%, #FFFFFF 100%)'
        };
    }
    return {
        background: bgColor
    };
};
// 代金券数据结构解析
export var formatFreeWithCreditIteration = function(properties) {
    var _loop = function(i) {
        var item = properties[keys[i]];
        var ref = dataFormat.clearRandomKey(item.properties), _title = ref.title, title = _title === void 0 ? {} : _title, _agreement = ref.agreement, agreement = _agreement === void 0 ? {} : _agreement, _price = ref.price, price = _price === void 0 ? {} : _price, _txt = ref.txt, txt1 = _txt === void 0 ? {} : _txt, _href = ref.href, href = _href === void 0 ? {} : _href, _type = ref.type, type = _type === void 0 ? {} : _type, _isConnect = ref.isConnect, isConnect = _isConnect === void 0 ? {} : _isConnect, _isLink = ref.isLink, isLink = _isLink === void 0 ? {} : _isLink, _event = ref.event, event = _event === void 0 ? {} : _event, _commodity = ref.commodity, commodity = _commodity === void 0 ? {} : _commodity;
        var resultAgreement = (agreement.default || []).map(function(agreementItem) {
            var agreementKeys = Object.keys(agreementItem);
            var txt = agreementItem[agreementKeys[0]] || '';
            return {
                txt: txt
            };
        });
        var buttonConfig = {
            txt: txt1.default || '',
            colType: 'blue',
            text: '文字',
            'text-icon': '文字+图标',
            sizeType: 'middle',
            alignType: 'center',
            onCallback: null
        };
        var itemData = {
            type: type.default || '1',
            title: title.default || '',
            agreement: resultAgreement,
            price: price.default || '0',
            isConnect: isConnect.default || false,
            isLink: isLink.default || false,
            event: event.default || '',
            commodity: commodity.default || '',
            buttonConfig: buttonConfig,
            href: href.default || ''
        };
        buttonConfig.onCallback = function formatFreeWithCreditIteration() {
            asyncReceiveCommodity(itemData);
        };
        resultConfiguration.push(itemData);
    };
    var keys = Object.keys(properties); // 对应属性的key值，规则按3个为一组数据
    var modTitle = properties[keys[0]].default; // 第一条数据是模块名称
    keys.shift(); // 把模块名移出，继续遍历后面的数据
    // 处理组件背景色字段
    var bgColor = dataFormat.getComponentsBgColor(properties, keys);
    var ref2 = dataFormat.clearRandomKey(properties), _headConfig = ref2.headConfig, headConfig = _headConfig === void 0 ? {} : _headConfig;
    var ref1 = dataFormat.clearRandomKey(headConfig.properties), _description = ref1.description, description = _description === void 0 ? {} : _description, _list = ref1.list, list = _list === void 0 ? {} : _list;
    // 处理头部配置
    var resultHeadList = (list.default || []).map(function(headItem) {
        var ref = dataFormat.clearRandomKey(headItem), _txt = ref.txt, txt = _txt === void 0 ? '' : _txt, _headCase = ref.headCase, headCase = _headCase === void 0 ? {} : _headCase;
        var _href = headCase.href, href = _href === void 0 ? '' : _href, _type = headCase.type, type = _type === void 0 ? 'a' : _type, _modalTitle = headCase.modalTitle, modalTitle = _modalTitle === void 0 ? '' : _modalTitle, _richTextContent = headCase.richTextContent, richTextContent = _richTextContent === void 0 ? '' : _richTextContent, _richBtnTxt = headCase.richBtnTxt, richBtnTxt = _richBtnTxt === void 0 ? [] : _richBtnTxt;
        return {
            txt: txt,
            href: href,
            type: type,
            modalTitle: modalTitle,
            richTextContent: richTextContent,
            richBtnTxt: richBtnTxt
        };
    });
    var resultHeadConfig = {
        description: description.default || '',
        list: resultHeadList
    };
    keys.shift(); // 把head配置移出，继续遍历后面的数据
    var resultConfiguration = [];
    for(var i = 0; i < keys.length; i++)_loop(i);
    return {
        modTitle: modTitle,
        headConfig: resultHeadConfig,
        configuration: resultConfiguration,
        bgColor: bgColor
    };
};
// 折扣活动的错误弹窗提示处理
export var asyncErrorDialog = function(info) {
    var _code = info.code, code = _code === void 0 ? '' : _code;
    doVerifyCouponResult({
        eventType: ACTIVITY_TYPE.DISCOUNT
    }, code);
};
// 折扣活动的错误弹窗提示处理
export var asyncRegisterStepDialog = function() {
    Modal.alert({
        size: 'small',
        icon: 'info-circle',
        title: t('Incomplete account information'),
        content: t('After completing the account information, you can enter the console'),
        btnOkMsg: t('To improve'),
        btnCancelMsg: t('Cancel'),
        onOk: function onOk() {
            window.location.href = '/account/register/completion';
        }
    });
};
// 账号未开户，账号已绑卡弹窗提示
export var asyncAccountNoCardDialog = function() {
    Modal.alert({
        size: 'small',
        icon: 'info-circle',
        title: t('Tips'),
        content: t('Your account information is currently being processed. Please come back later to participate in special offers.'),
        btnOkMsg: t('I got it'),
        showCloseIcon: true
    });
};
// trtc-企业版 查询sdkappid应用为空提示
export var asyncNoSdkAppInfoDialog = function() {
    Modal.alert({
        size: 'small',
        icon: 'info-circle',
        title: t('Tips'),
        content: t('Please go to the console to create an application first'),
        btnOkMsg: t('To console'),
        onOk: function onOk() {
            window.location.href = 'https://console.tencentcloud.com/trtc';
        },
        showCloseIcon: true
    });
};
// 多语言翻译绑定到windows提供给素材库使用
export var infoTrans = function() {
    var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(info) {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    t(info);
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function infoTrans(info) {
        return _ref.apply(this, arguments);
    };
}();
if ("object" !== 'undefined') {
    window.asyncReceiveCommodity = asyncReceiveCommodity;
    window.formatFreeWithCreditIteration = formatFreeWithCreditIteration;
    window.asyncErrorDialog = asyncErrorDialog;
    window.infoTrans = infoTrans;
    window.asyncRegisterStepDialog = asyncRegisterStepDialog;
    window.asyncAccountNoCardDialog = asyncAccountNoCardDialog;
    window.asyncNoSdkAppInfoDialog = asyncNoSdkAppInfoDialog;
    window.asyncSubmitFormTable = asyncSubmitFormTable;
    window.submitForm = submitForm;
}
